import * as React from "react";

export function PremiumTag() {
  return (
    <div className="text-sweet-orange-800 bg-sweet-orange-100 rounded-md p-1 text-xs">
      Premium
    </div>
  );
}
